import { render, staticRenderFns } from "./IconTeam.vue?vue&type=template&id=3709c1e5&functional=true&"
import script from "./IconTeam.vue?vue&type=script&lang=js&"
export * from "./IconTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports